/* RF Abayas - quick-add accessories (cart drawer + cart page).
   Delegated listeners, bound once, so they keep working after the drawer / cart footer re-renders.
   04-11-2026: the card photo follows the selected colour (variant image), including the initial selection. */
(function () {
  if (window.__rfQuickAddBound) return;
  window.__rfQuickAddBound = true;

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var productCache = {};

  function getProduct(handle) {
    if (!productCache[handle]) {
      productCache[handle] = fetch(root + 'products/' + handle + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    }
    return productCache[handle];
  }

  function sized(src) {
    try {
      var u = new URL(src.indexOf('//') === 0 ? 'https:' + src : src, window.location.origin);
      u.searchParams.set('width', '200');
      return u.toString();
    } catch (e) {
      return src;
    }
  }

  // Show the photo of the selected variant on its card (falls back to the product photo if the variant has none).
  async function updateImage(select) {
    var card = select.closest('.rf-qa__card');
    if (!card) return;
    var img = card.querySelector('.rf-qa__img');
    var link = card.querySelector('.rf-qa__name');
    if (!img || !link) return;
    var m = (link.getAttribute('href') || '').match(/\/products\/([^\/?#]+)/);
    if (!m) return;
    var product = await getProduct(m[1]);
    if (!product) return;
    var vid = Number(select.value);
    var variant = (product.variants || []).find(function (v) { return v.id === vid; });
    var src = variant && variant.featured_image && variant.featured_image.src;
    if (!img.dataset.rfDefault) img.dataset.rfDefault = img.getAttribute('src');
    img.removeAttribute('srcset');
    img.src = src ? sized(src) : img.dataset.rfDefault;
  }

  function syncAll() {
    document.querySelectorAll('.rf-qa__select').forEach(function (s) {
      if (s.dataset.rfSynced) return;
      s.dataset.rfSynced = '1';
      updateImage(s);
    });
  }

  var timer = null;
  new MutationObserver(function () {
    if (timer) return;
    timer = setTimeout(function () {
      timer = null;
      syncAll();
    }, 100);
  }).observe(document.body || document.documentElement, { childList: true, subtree: true });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncAll);
  } else {
    syncAll();
  }

  // Stop the variant <select> change from reaching the cart's quantity-update handler.
  document.addEventListener(
    'change',
    function (e) {
      if (e.target && e.target.closest && e.target.closest('.rf-qa')) {
        if (e.target.matches && e.target.matches('.rf-qa__select')) updateImage(e.target);
        e.stopPropagation();
      }
    },
    true
  );

  document.addEventListener('click', async function (e) {
    var btn = e.target.closest && e.target.closest('[data-rf-quick-add]');
    if (!btn || btn.disabled) return;
    e.preventDefault();

    var card = btn.closest('.rf-qa__card');
    var select = card && card.querySelector('select');
    var variantId = select ? select.value : btn.getAttribute('data-variant-id');
    var label = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding…';

    try {
      var onCartPage = /\/cart\/?$/.test(window.location.pathname);
      var payload = { items: [{ id: Number(variantId), quantity: 1 }] };
      if (!onCartPage) {
        payload.sections = 'cart-drawer,cart-icon-bubble';
        payload.sections_url = window.location.pathname;
      }
      var res = await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload)
      });
      var data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || data.message || 'Could not add');

      if (onCartPage) {
        // Full cart page: reload so the items list, bar and totals all refresh.
        window.location.reload();
        return;
      }
      var drawer = document.querySelector('cart-drawer');
      if (drawer && data.sections && typeof drawer.renderContents === 'function') {
        drawer.renderContents(data);
      } else {
        window.location.reload();
      }
    } catch (err) {
      btn.disabled = false;
      btn.textContent = 'Unavailable';
      setTimeout(function () {
        btn.textContent = label;
      }, 2000);
    }
  });
})();
